
import {
    GET_PARTNER_FAILED, GET_PARTNER_LOADING, GET_PARTNER_SUCCESS, GET_PARTNER_REMOVE
} from "../types";
import api from "../../api";
import { getPartnerByIdEndpoint } from "../../api/apisUrl";
import { apiError } from "../../models";

export const getPartnerById = ( id: any, token: any) => {
    return async (
        dispatch: (arg0: {
            type: string;
            loading?: boolean;
            payload?: any;
            partnerId?: any;
            error?: any;
        }) => void
    ) => {
        dispatch({ type: GET_PARTNER_LOADING, loading: true });
        await api
            .get(getPartnerByIdEndpoint(id),
                {
                    headers: {
                        "Content-type": "application/json",
                         Authorization: `Bearer ${token}`, 
                    },
                }
            )
            .then((res) => {
                dispatch({ type: GET_PARTNER_LOADING, loading: false });
                dispatch({
                    type: GET_PARTNER_SUCCESS,
                    payload: res.data,
                    partnerId: id,
                });
            })
            .catch((err) => {
                apiError(GET_PARTNER_LOADING, GET_PARTNER_FAILED, err, dispatch);
            });
    };
};


export const RemovePartnerData = () => {
    return {
        type: GET_PARTNER_REMOVE
    }
}